<ng-container>
    <p-table #dt [columns]="columns" [value]="data" [tableStyle]="tableStyle" [scrollable]="scrollable" [scrollHeight]="scrollHeight" 
    (onSort)="onSort($event)" [customSort]="true" (onFilter)="onFilter($event)" [reorderableColumns]="reorderableColumns" (onColReorder)="onColReorder($event)">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [ngStyle]="headerStyles" [pSortableColumn]="col.field" pReorderableColumn>
                    {{ col.headerName }} <p-sortIcon [field]="col.field"/>
                </th>
            </tr>
            <tr>
                <th *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.inputType">
                        <!-- Dropdown -->
                        <p-columnFilter *ngSwitchCase="'dropdown'" [field]="col.field" [showMenu]="false"  matchMode="equals">
                            <ng-template pTemplate="filter" let-val let-filter="filterCallback">
                                <p-dropdown appendTo="body" [options]="col.filter" [placeholder]="'Search by ' + col.headerName" [showClear]="true" [ngModelOptions]="{standalone: true}" (onChange)="filterCallback($event, col.field)" [filter]="true"/>
                            </ng-template>
                        </p-columnFilter>

                        <!-- Input -->
                        <p-columnFilter *ngSwitchDefault type="text" [field]="col.field" [placeholder]="'Search by ' + col.headerName"/>
                    </ng-container>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" [ngStyle]="gridStyles">
                    {{ row[col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <h5> 
        <ng-container *ngIf="showingItems !== totalItems">Showing Items: {{showingItems}}&nbsp;&nbsp;</ng-container>
        Total Items: {{totalItems}} 
    </h5>
</ng-container>